import { Spinner } from 'react-bootstrap';
import styled from 'styled-components';

export const StyledLoader = styled.div<IProps>`
  ${({ overlay, fullScreen }) =>
    overlay &&
    !fullScreen &&
    `position: absolute;
  top: calc(50% - 10px);
  left: calc(50% - 10px);`}

  ${({ overlay, fullScreen }) =>
    overlay &&
    fullScreen &&
    `position: fixed;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  user-select: none;
  width: 100%;
  height: 100%;
  z-index: 1000;
  background-color: rgba(0,0,0,0.5);
  `}
`;

interface IProps {
  overlay?: boolean;
  fullScreen?: boolean;
}

export const Loader = ({ overlay = true, fullScreen }: IProps) => {
  return (
    <StyledLoader overlay={overlay} fullScreen={fullScreen}>
      <Spinner animation="border" variant="primary" />
    </StyledLoader>
  );
};
